import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col span-12" }
const _hoisted_3 = { class: "filters-heading mb-10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col span-6" }
const _hoisted_6 = { class: "text-label" }
const _hoisted_7 = { class: "col span-6 send-to" }
const _hoisted_8 = { class: "text-label" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col span-6" }
const _hoisted_11 = { class: "col span-6" }

import { ref } from 'vue';
import LabeledInput from '@components/Form/LabeledInput/LabeledInput.vue';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import ArrayList from '@shell/components/form/ArrayList.vue';
import { AuditPolicy, FilterRule } from '@shell/edit/auditlog.cattle.io.auditpolicy/types';

// Component Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
  value: {
    type:    Object,
    default: () => ({})
  },
  mode: {
    type:    String,
    default: 'create'
  },
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Default Values & Reactive Spec
const defaults: AuditPolicy = { filters: [] };
const spec = ref<AuditPolicy>({ ...defaults, ...props.value });
const defaultAddValue: FilterRule = {
  action:     'allow',
  requestURI: '',
};

// Methods
function addRow(key: 'action' | 'requestURI', filters: FilterRule[]) {
  const valueToEmit = { ...props.value, ...spec.value };

  valueToEmit.filters = filters;

  emit('update:value', valueToEmit);
}

function updateRow(key: 'action' | 'requestURI', index: number, value: string) {
  const valueToEmit = { ...props.value, ...spec.value };

  if (!valueToEmit.filters) {
    valueToEmit.filters = [];
  }

  // Ensure the filter exists at the given index
  if (!valueToEmit.filters[index]) {
    valueToEmit.filters[index] = { action: '', requestURI: '' };
  }

  valueToEmit.filters[index][key] = value;
  emit('update:value', valueToEmit);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ArrayList, {
          key: "headers",
          value: spec.value.filters,
          "onUpdate:value": [
            _cache[0] || (_cache[0] = ($event: any) => ((spec.value.filters) = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (addRow('action', $event)))
          ],
          "value-placeholder": _ctx.t('auditPolicy.filters.placeholder'),
          "add-label": _ctx.t('auditPolicy.filters.add'),
          mode: __props.mode,
          protip: false,
          defaultAddValue: defaultAddValue,
          "show-header": true
        }, {
          "column-headers": _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('auditPolicy.filters.action.title')), 1)
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('auditPolicy.filters.requestURI.title')), 1)
                ])
              ])
            ])
          ]),
          columns: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(LabeledSelect, {
                  value: scope.row.value.action,
                  "onUpdate:value": [($event: any) => ((scope.row.value.action) = $event), ($event: any) => (updateRow('action', scope.i, $event))],
                  options: [{ value: 'allow', label: _ctx.t('auditPolicy.filters.action.allow')},{ value: 'deny', label: _ctx.t('auditPolicy.filters.action.deny') }],
                  mode: __props.mode,
                  placeholder: _ctx.t('auditPolicy.filters.action.placeholder')
                }, null, 8, ["value", "onUpdate:value", "options", "mode", "placeholder"])
              ]),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(LabeledInput, {
                  value: scope.row.value.requestURI,
                  "onUpdate:value": [($event: any) => ((scope.row.value.requestURI) = $event), ($event: any) => (updateRow('requestURI', scope.i, $event, ))],
                  mode: __props.mode,
                  placeholder: _ctx.t('auditPolicy.filters.requestURI.placeholder')
                }, null, 8, ["value", "onUpdate:value", "mode", "placeholder"])
              ])
            ])
          ]),
          _: 1,
          __: [4]
        }, 8, ["value", "value-placeholder", "add-label", "mode"])
      ])
    ])
  ]))
}
}

})